var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPiccolo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 584,
    height: 607,
    viewBox: "0 0 584 607",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290.204 486.219L95.0625 373.553V205.535L290.204 318.2V486.219Z",
    fill: "#B6CEFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.778 312.962L113.516 292.604V235.496L148.778 255.855V312.962Z",
    fill: "#85AFFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.626 257.614L117.859 251.397V242.496L128.626 248.712V257.614Z",
    fill: "#F7F8FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.438 266.742L133.672 260.526V251.625L144.438 257.841V266.742Z",
    fill: "#F7F8FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.626 270.688L117.859 264.472V255.57L128.626 261.786V270.688Z",
    fill: "#F7F8FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.438 279.816L133.672 273.6V264.699L144.438 270.915V279.816Z",
    fill: "#F7F8FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.626 283.762L117.859 277.546V268.645L128.626 274.86V283.762Z",
    fill: "#F7F8FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.438 292.891L133.672 286.674V277.773L144.438 283.99V292.891Z",
    fill: "#F7F8FB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.626 296.835L117.859 290.621V281.719L128.626 287.934V296.835Z",
    fill: "#F7F8FB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144.438 305.964L133.672 299.749V290.848L144.438 297.062V305.964Z",
    fill: "#F7F8FB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M148.778 384.691L113.516 364.334V307.227L148.778 327.584V384.691Z",
    fill: "#85AFFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.626 329.343L117.859 323.128V314.227L128.626 320.442V329.343Z",
    fill: "#F7F8FB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.438 338.473L133.672 332.257V323.355L144.438 329.571V338.473Z",
    fill: "#F7F8FB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M128.626 342.417L117.859 336.202V327.301L128.626 333.516V342.417Z",
    fill: "#F7F8FB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M144.438 351.547L133.672 345.332V336.43L144.438 342.646V351.547Z",
    fill: "#F7F8FB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M128.626 355.492L117.859 349.276V340.375L128.626 346.591V355.492Z",
    fill: "#F7F8FB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M144.438 364.621L133.672 358.406V349.504L144.438 355.719V364.621Z",
    fill: "#F7F8FB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M128.626 368.566L117.859 362.35V353.449L128.626 359.664V368.566Z",
    fill: "#F7F8FB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M144.438 377.696L133.672 371.48V362.578L144.438 368.795V377.696Z",
    fill: "#F7F8FB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M210.262 348.461L175 328.103V270.996L210.262 291.354V348.461Z",
    fill: "#85AFFB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M190.11 293.114L179.344 286.897V277.996L190.11 284.213V293.114Z",
    fill: "#F7F8FB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M205.923 302.242L195.156 296.027V287.125L205.923 293.341V302.242Z",
    fill: "#F7F8FB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M190.11 306.187L179.344 299.971V291.07L190.11 297.285V306.187Z",
    fill: "#F7F8FB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M205.923 315.316L195.156 309.1V300.199L205.923 306.415V315.316Z",
    fill: "#F7F8FB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M210.262 440.065L175 419.708V360.781L210.262 381.14V440.065Z",
    fill: "#85AFFB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M179.18 422.119L190.948 428.913V373.95L179.18 367.156V422.119Z",
    fill: "#B6CEFB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M194.312 430.858L206.081 437.653V382.689L194.312 375.895V430.858Z",
    fill: "#B6CEFB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M271.754 383.961L236.492 363.603V306.496L271.754 326.854V383.961Z",
    fill: "#85AFFB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M251.602 328.614L240.836 322.397V313.496L251.602 319.713V328.614Z",
    fill: "#F7F8FB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M267.415 337.742L256.648 331.527V322.625L267.415 328.841V337.742Z",
    fill: "#F7F8FB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M251.602 341.687L240.836 335.471V326.57L251.602 332.786V341.687Z",
    fill: "#F7F8FB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M267.415 350.816L256.648 344.601V335.699L267.415 341.915V350.816Z",
    fill: "#F7F8FB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M251.602 354.761L240.836 348.546V339.645L251.602 345.859V354.761Z",
    fill: "#F7F8FB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M267.415 363.891L256.648 357.674V348.773L267.415 354.99V363.891Z",
    fill: "#F7F8FB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M251.602 367.836L240.836 361.62V352.719L251.602 358.934V367.836Z",
    fill: "#F7F8FB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M267.415 376.964L256.648 370.749V361.848L267.415 368.063V376.964Z",
    fill: "#F7F8FB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M271.754 455.692L236.492 435.334V378.227L271.754 398.585V455.692Z",
    fill: "#85AFFB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M251.602 400.344L240.836 394.129V385.227L251.602 391.442V400.344Z",
    fill: "#F7F8FB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M267.415 409.472L256.648 403.257V394.355L267.415 400.571V409.472Z",
    fill: "#F7F8FB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M251.602 413.417L240.836 407.203V398.301L251.602 404.516V413.417Z",
    fill: "#F7F8FB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M267.415 422.547L256.648 416.331V407.43L267.415 413.646V422.547Z",
    fill: "#F7F8FB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M251.602 426.493L240.836 420.276V411.375L251.602 417.591V426.493Z",
    fill: "#F7F8FB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M267.415 435.621L256.648 429.405V420.504L267.415 426.719V435.621Z",
    fill: "#F7F8FB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M251.602 439.566L240.836 433.35V424.449L251.602 430.665V439.566Z",
    fill: "#F7F8FB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M267.415 448.697L256.648 442.48V433.578L267.415 439.795V448.697Z",
    fill: "#F7F8FB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M193.482 338.772L191.789 337.796V280.688L193.482 281.665V338.772Z",
    fill: "#B6CEFB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M290.204 309.572L95.0625 196.906V205.538L290.204 318.203V309.572Z",
    fill: "#85AFFB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0625 196.904L290.204 94.4609V309.57L95.0625 196.904Z",
    fill: "#003EB3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M105.646 236.433L95.0625 230.322V217.113L105.646 223.224V236.433Z",
    fill: "#85AFFB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M105.646 261.978L95.0625 255.866V242.656L105.646 248.768V261.978Z",
    fill: "#85AFFB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M105.646 287.524L95.0625 281.412V268.203L105.646 274.314V287.524Z",
    fill: "#85AFFB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M105.646 313.071L95.0625 306.96V293.75L105.646 299.861V313.071Z",
    fill: "#85AFFB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M105.646 338.614L95.0625 332.502V319.293L105.646 325.404V338.614Z",
    fill: "#85AFFB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M105.646 364.16L95.0625 358.049V344.84L105.646 350.95V364.16Z",
    fill: "#85AFFB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M279.617 336.878L290.201 342.989V329.78L279.617 323.668V336.878Z",
    fill: "#85AFFB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M279.617 362.425L290.201 368.535V355.326L279.617 349.215V362.425Z",
    fill: "#85AFFB"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M279.617 387.968L290.201 394.079V380.869L279.617 374.758V387.968Z",
    fill: "#85AFFB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M279.617 413.514L290.201 419.625V406.415L279.617 400.305V413.514Z",
    fill: "#85AFFB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M279.617 439.061L290.201 445.173V431.963L279.617 425.852V439.061Z",
    fill: "#85AFFB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M279.617 464.603L290.201 470.714V457.505L279.617 451.395V464.603Z",
    fill: "#85AFFB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M290.204 498.77L95.0625 386.104V373.555L290.204 486.221V498.77Z",
    fill: "#85AFFB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M485.347 196.904L290.203 94.4609V309.57L485.347 196.904Z",
    fill: "#002466"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M485.347 373.557L290.203 486.223V318.204L485.347 205.539V373.557Z",
    fill: "#85AFFB"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M343.916 363.607L308.656 383.965V326.858L343.916 306.5V363.607Z",
    fill: "#5C93F8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M323.766 331.531L313 337.746V328.844L323.766 322.629V331.531Z",
    fill: "#C2CDDD"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M339.578 322.401L328.812 328.618V319.716L339.578 313.5V322.401Z",
    fill: "#C2CDDD"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M323.766 344.605L313 350.82V341.919L323.766 335.703V344.605Z",
    fill: "#C2CDDD"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M339.578 335.475L328.812 341.691V332.79L339.578 326.574V335.475Z",
    fill: "#C2CDDD"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M323.766 357.678L313 363.895V354.994L323.766 348.777V357.678Z",
    fill: "#C2CDDD"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M339.578 348.549L328.812 354.765V345.863L339.578 339.648V348.549Z",
    fill: "#C2CDDD"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M323.766 370.753L313 376.968V368.067L323.766 361.852V370.753Z",
    fill: "#C2CDDD"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M339.578 361.624L328.812 367.84V358.938L339.578 352.723V361.624Z",
    fill: "#C2CDDD"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M343.916 435.338L308.656 455.696V398.589L343.916 378.23V435.338Z",
    fill: "#5C93F8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M323.766 403.26L313 409.476V400.575L323.766 394.359V403.26Z",
    fill: "#C2CDDD"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M339.578 394.132L328.812 400.348V391.446L339.578 385.23V394.132Z",
    fill: "#C2CDDD"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M323.766 416.335L313 422.551V413.65L323.766 407.434V416.335Z",
    fill: "#C2CDDD"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M339.578 407.207L328.812 413.421V404.52L339.578 398.305V407.207Z",
    fill: "#C2CDDD"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M323.766 429.409L313 435.624V426.722L323.766 420.508V429.409Z",
    fill: "#C2CDDD"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M339.578 420.28L328.812 426.496V417.595L339.578 411.379V420.28Z",
    fill: "#C2CDDD"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M323.766 442.484L313 448.7V439.798L323.766 433.582V442.484Z",
    fill: "#C2CDDD"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M339.578 433.354L328.812 439.57V430.669L339.578 424.453V433.354Z",
    fill: "#C2CDDD"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M466.895 292.608L431.633 312.966V255.859L466.895 235.5V292.608Z",
    fill: "#5C93F8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M446.743 260.53L435.977 266.746V257.844L446.743 251.629V260.53Z",
    fill: "#C2CDDD"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M462.555 251.401L451.789 257.618V248.716L462.555 242.5V251.401Z",
    fill: "#C2CDDD"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M446.743 273.604L435.977 279.82V270.919L446.743 264.703V273.604Z",
    fill: "#C2CDDD"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M462.555 264.476L451.789 270.692V261.79L462.555 255.574V264.476Z",
    fill: "#C2CDDD"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M446.743 286.678L435.977 292.895V283.994L446.743 277.777V286.678Z",
    fill: "#C2CDDD"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M462.555 277.55L451.789 283.766V274.864L462.555 268.648V277.55Z",
    fill: "#C2CDDD"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M446.743 299.753L435.977 305.968V297.066L446.743 290.852V299.753Z",
    fill: "#C2CDDD"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M462.555 290.625L451.789 296.839V287.938L462.555 281.723V290.625Z",
    fill: "#C2CDDD"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M466.895 364.338L431.633 384.695V327.588L466.895 307.23V364.338Z",
    fill: "#5C93F8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M446.743 332.261L435.977 338.477V329.575L446.743 323.359V332.261Z",
    fill: "#C2CDDD"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M462.555 323.132L451.789 329.347V320.446L462.555 314.23V323.132Z",
    fill: "#C2CDDD"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M446.743 345.336L435.977 351.551V342.65L446.743 336.434V345.336Z",
    fill: "#C2CDDD"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M462.555 336.206L451.789 342.421V333.52L462.555 327.305V336.206Z",
    fill: "#C2CDDD"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M446.743 358.41L435.977 364.624V355.723L446.743 349.508V358.41Z",
    fill: "#C2CDDD"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M462.555 349.28L451.789 355.496V346.594L462.555 340.379V349.28Z",
    fill: "#C2CDDD"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M446.743 371.484L435.977 377.7V368.798L446.743 362.582V371.484Z",
    fill: "#C2CDDD"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M462.555 362.354L451.789 368.57V359.668L462.555 353.453V362.354Z",
    fill: "#C2CDDD"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M406.253 327.619L370.992 347.977V290.87L406.253 270.512V327.619Z",
    fill: "#5C93F8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M386.102 295.543L375.336 301.759V292.857L386.102 286.641V295.543Z",
    fill: "#C2CDDD"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M401.914 286.413L391.148 292.628V283.727L401.914 277.512V286.413Z",
    fill: "#C2CDDD"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M386.102 308.617L375.336 314.831V305.93L386.102 299.715V308.617Z",
    fill: "#C2CDDD"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M401.914 299.487L391.148 305.703V296.801L401.914 290.586V299.487Z",
    fill: "#C2CDDD"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M386.102 321.69L375.336 327.907V319.005L386.102 312.789V321.69Z",
    fill: "#C2CDDD"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M401.914 312.561L391.148 318.777V309.875L401.914 303.66V312.561Z",
    fill: "#C2CDDD"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M386.102 334.764L375.336 340.98V332.079L386.102 325.863V334.764Z",
    fill: "#C2CDDD"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M401.914 325.635L391.148 331.852V322.95L401.914 316.734V325.635Z",
    fill: "#C2CDDD"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M406.253 399.349L370.992 419.708V362.6L406.253 342.242V399.349Z",
    fill: "#5C93F8"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M386.102 367.272L375.336 373.488V364.587L386.102 358.371V367.272Z",
    fill: "#C2CDDD"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M401.914 358.144L391.148 364.36V355.458L401.914 349.242V358.144Z",
    fill: "#C2CDDD"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M386.102 380.346L375.336 386.563V377.662L386.102 371.445V380.346Z",
    fill: "#C2CDDD"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M401.914 371.218L391.148 377.433V368.532L401.914 362.316V371.218Z",
    fill: "#C2CDDD"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M386.102 393.421L375.336 399.636V390.734L386.102 384.52V393.421Z",
    fill: "#C2CDDD"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M401.914 384.292L391.148 390.508V381.607L401.914 375.391V384.292Z",
    fill: "#C2CDDD"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M386.102 406.496L375.336 412.712V403.81L386.102 397.594V406.496Z",
    fill: "#C2CDDD"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M401.914 397.366L391.148 403.581V394.68L401.914 388.465V397.366Z",
    fill: "#C2CDDD"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M388.622 337.799L386.93 338.776V281.669L388.622 280.691V337.799Z",
    fill: "#B6CEFB"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M485.347 196.906L290.203 309.572V318.203L485.347 205.538V196.906Z",
    fill: "#5C93F8"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M300.789 336.878L290.203 342.989V329.78L300.789 323.668V336.878Z",
    fill: "#5C93F8"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M300.789 362.425L290.203 368.535V355.326L300.789 349.215V362.425Z",
    fill: "#5C93F8"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M300.789 387.968L290.203 394.079V380.869L300.789 374.758V387.968Z",
    fill: "#5C93F8"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M300.789 413.514L290.203 419.625V406.415L300.789 400.305V413.514Z",
    fill: "#5C93F8"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M300.789 439.061L290.203 445.173V431.963L300.789 425.852V439.061Z",
    fill: "#5C93F8"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M300.789 464.603L290.203 470.714V457.505L300.789 451.395V464.603Z",
    fill: "#5C93F8"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M474.758 236.437L485.343 230.326V217.117L474.758 223.228V236.437Z",
    fill: "#5C93F8"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M474.758 261.982L485.343 255.87V242.66L474.758 248.772V261.982Z",
    fill: "#5C93F8"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M474.758 287.528L485.343 281.416V268.207L474.758 274.318V287.528Z",
    fill: "#5C93F8"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M474.758 313.074L485.343 306.964V293.754L474.758 299.865V313.074Z",
    fill: "#5C93F8"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M474.758 338.618L485.343 332.506V319.297L474.758 325.408V338.618Z",
    fill: "#5C93F8"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M474.758 364.164L485.343 358.053V344.844L474.758 350.954V364.164Z",
    fill: "#5C93F8"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M485.347 386.104L290.203 498.77V486.221L485.347 373.555V386.104Z",
    fill: "#5C93F8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiccolo);
export default __webpack_public_path__ + "static/media/piccolo.cc77bdc606015f03a84a64fd135c07a3.svg";
export { ForwardRef as ReactComponent };